import React from 'react';
import {Link} from 'react-router-dom'

import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import AppBar from '@material-ui/core/AppBar';




export default function MenuDemo() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

    return (
      <header className='header'>
        <h1 style={{margin:'0px', padding:'60px'}}>
          Tiffany Lewis, Ph.D.
        </h1>
        <nav>
          <AppBar className='navBar' color='inherit' position="static">
              <div>
                  <Button style={{color: '#470083', textShadow: "1px 1px #997aeb"}} className='navBarBtn' component={Link} to='/'>Home</Button>
                  <Button style={{color: '#470083', textShadow: "1px 1px #997aeb"}} className='navBarBtn' component={Link} to='/AboutMe'>About Me</Button>
                  <Button
                    style={{color: '#470083', textShadow: "1px 1px #997aeb"}} className='navBarBtn'
                    id="basic-button"
                    aria-controls="basic-menu"
                    aria-haspopup="true"
                    aria-expanded={open ? 'true' : undefined}
                    onClick={handleClick}
                  >
                    Research Menu
                  </Button>
                  <Menu
                    id="basic-menu"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    MenuListProps={{
                      'aria-labelledby': 'basic-button',
                    }}
                  >
                    <MenuItem onClick={handleClose} component={Link} to='/Research'>Overview</MenuItem>
                    <MenuItem onClick={handleClose} component={Link} to='/BlazarTheory'>Blazars</MenuItem>
                    <MenuItem onClick={handleClose} component={Link} to='/AGNTheory'>Other AGN</MenuItem>
                     <MenuItem onClick={handleClose} component={Link} to='/BinaryStars'>Cataclysmic Variables</MenuItem>
                     <MenuItem onClick={handleClose} component={Link} to='/Exoplanets'>Exoplanets</MenuItem>
                  </Menu>

                  <Button style={{color: '#470083', textShadow: "1px 1px #997aeb"}} className='navBarBtn' component={Link} to='/Teaching'>Teaching</Button>
                  <Button style={{color: '#470083', textShadow: "1px 1px #997aeb"}} className='navBarBtn' component={Link} to='/Outreach'>Outreach</Button>
              </div>
          </AppBar>

        </nav>
      </header>

    )
  }



// WEBPACK FOOTER //
// ./src/Components/Header.js